// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"MainHeader-module--headerWrapper--oAXM3","navWrapper":"MainHeader-module--navWrapper--1mvo5"};